import React, { useMemo } from 'react'
import { unix } from 'dayjs'
import { Pagination, Typography } from '@mui/material'
import AddressCell from './AddressCell'
import StatusCell from './StatusCell'
import AssetCell from './AssetCell'
import BridgeFeeCell from './BridgeFeeCell'
import Table, { ITableColumn } from '@/components/Table'
import { FlexCol } from '@/components/common/Columns'
import { RowCenter } from '@/components/common/Rows'
import { TxHistory } from '@/api/dashboard/types'
import { SupportedTicker } from '@/constants/token'

const TransactionHistoryTable = ({
  loading,
  data,
  totalPage,
  currentPage,
  changeCurrent,
}: {
  loading: boolean
  data?: TxHistory[]
  totalPage: number
  currentPage: number
  changeCurrent: (current: number) => void
}) => {
  const columns: ITableColumn<TxHistory>[] = useMemo(
    () => [
      {
        title: 'Date',
        render(col, data) {
          return (
            <Typography sx={{ fontSize: '16px', fontWeight: 400 }}>
              {unix(data.ctime).format('YYYY.MM.DD HH:mm')}
            </Typography>
          )
        },
      },
      {
        title: '(Asset)Amount',
        render(col, data) {
          return (
            <AssetCell tokenName={data.coin as SupportedTicker} chainId={data.from_chain_id} amount={data.amount} />
          )
        },
      },
      {
        title: 'From',
        render(col, data) {
          return <AddressCell chainId={data.from_chain_id} address={data.from_addr} txId={data.from_tx_id} />
        },
      },
      {
        title: 'Status',
        render(col, data) {
          return <StatusCell status={data.from_status} time={data.from_tx_ts} />
        },
      },
      {
        title: 'To',
        render(col, data) {
          return <AddressCell chainId={data.to_chain_id} address={data.to_addr} txId={data.to_tx_id} />
        },
      },
      {
        title: 'Status',
        render(col, data) {
          return <StatusCell status={data.to_status} time={data.to_tx_ts} />
        },
      },
      {
        title: 'Bridge Fee',
        render(col, data) {
          return (
            <BridgeFeeCell
              tickerName={data.coin as SupportedTicker}
              chainId={data.from_chain_id}
              amount={data.bridge_fee}
            />
          )
        },
      },
    ],
    [],
  )

  return (
    <FlexCol>
      <Table
        loading={loading}
        datas={data}
        columns={columns}
        sx={{
          '.MuiTableRow-root': {
            verticalAlign: 'top',
          },
        }}
      />
      <RowCenter>
        {data?.length > 0 && (
          <Pagination
            sx={{
              py: 20,
              '& .MuiPaginationItem-root.Mui-selected': {
                background: '#BFFF0B',
                color: '#000000',
              },
            }}
            count={totalPage}
            page={currentPage}
            onChange={(_, selectedPage) => {
              changeCurrent(selectedPage)
            }}
            shape="rounded"
          />
        )}
      </RowCenter>
    </FlexCol>
  )
}

export default TransactionHistoryTable
